import React, { useState, useEffect, useRef } from 'react';
import '../../App.module.css';
import HeroSection from '../HeroSection';
import Footer from '../Footer';
import BackgroundComponent from '../Background';
import MottoComponent from '../MottoComponent';

/*
  Home page — refresh.

  Layout: Hero (looping video + glass card)
        → AIntro (dark band: lede + stats card)
        → Motto (cream, italic Latin, yellow accent block)
        → Footer.

  The three service cards (with lateral-translation scroll animation)
  moved to /what-we-do — see pages/WhatWeDo.js, which preserves the
  exact original IntersectionObserver setup.
*/
function Home() {
  // Animation refs preserved here in case you want to re-introduce
  // intersection-driven sections on the home page later. Currently the
  // home page doesn't have any animated sections.
  const [, setVisibleSections] = useState({});
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setVisibleSections((prev) => ({
            ...prev,
            [entry.target.id]: entry.isIntersecting,
          }));
        });
      },
      { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );

    const currentRefs = sectionRefs.current;
    currentRefs.forEach((ref) => { if (ref) observer.observe(ref); });

    return () => {
      currentRefs.forEach((ref) => { if (ref) observer.unobserve(ref); });
    };
  }, []);

  return (
    <div>
      <HeroSection />
      <BackgroundComponent />
      <MottoComponent />
      <Footer />
    </div>
  );
}

export default Home;
